import * as interactivethings from "./interactivethings";
import * as swissviz from "../patterns/swissviz";

const patterns = [swissviz, interactivethings];

export default patterns;
